const platformList = [
    { img: "/imgs/live/platform/router.png", platform: "路由器" },
    { img: "/imgs/live/platform/windows.png", platform: "Windows" },
    { img: "/imgs/live/platform/mac.png", platform: "Mac" },
    { img: "/imgs/live/platform/android.png", platform: "安卓手机" },

];
const platformList2 = [
    { img: "/imgs/live/platform/ios.png", platform: "苹果手机" },
    { img: "/imgs/live/platform/sdk.png", platform: "SDK接入" },
];
export const TiktokMobileSecond = () => {
    return (
        <div>
            <div className="flex flex-col items-center  [background:linear-gradient(180deg,rgba(255,255,255,1)_0%,rgba(247.94,246.21,255,1)_34.135%,rgba(232.12,243.25,255,1)_66.346%,rgba(255,255,255,1)_100%)] w-[100vw] px-[38px] pb-[20px]">
                <div className="text-[18px] font-bold text-[rgba(51,51,51,1)] mt-[25px]">全平台支持</div>
                <div className="flex justify-between w-full mt-[16px]">
                    {platformList.map((item) => (
                        <Item key={item.platform} title={item.platform} img={item.img} />
                    ))}
                </div>
                <div className="flex justify-between w-full mt-[16px]">
                    {platformList2.map((item) => (
                        <Item key={item.platform} title={item.platform} img={item.img} />
                    ))}
                    <img
                        src="/imgs/live/platform/software.png"
                        className="aspect-[138/57] w-[138px] h-[57px]"
                    />
                </div>
            </div>
        </div>
    )
}
const Item = (props: { title: string; img: string }) => {
    return (
        <div className="flex min-w-[57px] h-[57px] flex-col justify-center items-center flex-shrink-0">
            <img src={props.img} className="aspect-[57/57] w-[57px] h-[57px]" />

        </div>
    );
};